<template>
  <div class="header-section">
    <div class="header-wrap">
      <div class="grid-container header-container">
        <div class="header row no-gutters">
          <div class="left"></div>

          <div class="middle col-auto">
            <img class="flair" src="../../assets/flair.svg" alt="BG Flair">

            <img class="logo" src="../../assets/logotype-block.svg" alt="Marketing Remix">
          </div>

          <div class="right col">Quote to go here</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";
@import "../../assets/scss/mixins";

.header-section {
  margin-top: gu(2);
  margin-bottom: gu(4);

  @media only screen and (min-width: 40rem) {
    margin-top: gu(5.35);
    margin-bottom: gu(5);
  }
}

.header-container {
  padding: 0;
  max-width: 76rem;
}

.header {
  position: relative;
  flex-wrap: nowrap;
  z-index: 2;

  $edge-width: calc( calc( 100vw - #{$global-width} ) / 2 );

  .left {
    position: absolute;
    background-color: $white;
    top: 0;
    height: 100%;
    right: 100%;

    @media only screen and (min-width: #{$global-width}) {
      width: $edge-width;
    }
  }

  .middle {
    margin-left: gu(-4);
    
    @media only screen and (min-width: 40rem) {
      margin-left: gu(-3);
    }
  }

  .flair {
    position: absolute;
    top: 0;
    transform: translateY(-21%);
    height: auto;
    left: 14.5%;
    width: 64.187866927593%;
  }

  .logo {
    height: rem-calc(125);
    width: auto;
    position: relative;
    margin-left: rem-calc(-1);
    margin-right: rem-calc(-1);
    //left: -10%;

    @media only screen and (min-width: 40rem) {
      height: rem-calc(193);
    }
  }
  
  .right {
    position: relative;
    background-color: $white;


    &::after {
      position: absolute;
      content: '';
      background-color: $white;
      top: 0;
      height: 100%;
      left: 100%;

      @media only screen and (min-width: #{$global-width}) {
        width: $edge-width;
      }
    }
  }
}

</style>
